import { ITopicBase } from 'src/app/core/models/i-topic-base';
import { IContentPinned } from './i-content-pinned';
import { ITag } from './i-tag';

export interface IUpdateContentList {
  contentPinned: IContentPinned[];
  contentAdded: IContentToUpdate[];
  contentRemoved: IContentToUpdate[];
  topics: ITopicBase[];
  tags: ITag[];
  removeAllPinnedContent: boolean;
  user: string;
  name: string;
}
export class UpdateContentList implements IUpdateContentList {
  constructor(
    public contentAdded: IContentToUpdate[] = [],
    public contentPinned: IContentPinned[] = [],
    public contentRemoved: IContentToUpdate[] = [],
    public topics: ITopicBase[] = [],
    public tags: ITag[] = [],
    public removeAllPinnedContent: boolean = false,
    public user: string = '',
    public name: string = ''
  ) {}
}
interface IContentToUpdate {
  contentId: string;
  contentVersionId: string;
}
export class ContentToUpdate implements IContentToUpdate {
  constructor(public contentId: string, public contentVersionId: string) {}
}
